import axios from "axios";
import { getAuth } from "../helpers";

const headers = () => {
  return {
    headers: { Authorization: `Bearer ${getAuth()["token"]}` },
  };
};

const baseUrl = process.env.VUE_APP_API;

const login = (data) => axios.post(baseUrl + "login", data);
const routeDetails = (data) =>
  axios.post(baseUrl + "workProgressByTeam", data, headers());
const routeDetailsGPS = (data) =>
  axios.post(baseUrl + "routeDetailsGPS", data, headers());
const updateUser = (data) => axios.put(baseUrl + "updateUser", data, headers());
const storeUser = (data) => axios.post(baseUrl + "storeUser", data, headers());
const updateTeam = (data) => axios.put(baseUrl + "updateTeam", data, headers());
const updateProduct = (data) => axios.put(baseUrl + "updateProduct", data, headers());
const updateSurvey = (data) => axios.put(baseUrl + "updateSurvey", data, headers());
const storeTeam = (data) => axios.post(baseUrl + "storeTeam", data, headers());
const storeProduct = (data) => axios.post(baseUrl + "storeProduct", data, headers());
const storeSurvey = (data) => axios.post(baseUrl + "storeSurvey", data, headers());
const storeSurveyAnswer = (data, token) => {

  let mobileHeaders = () => {
    return {
      headers: { Authorization: `Bearer ${token}}` },
    };
  };

  return axios.post(baseUrl + "storeSurveyAnswer", data, mobileHeaders());
}
const storePromotion = (data) =>
  axios.post(baseUrl + "storePromotion", data, headers());
const updatePromotion = (data) =>
  axios.put(baseUrl + "updatePromotion", data, headers());
const checkPermission = (data) =>
  axios.post(baseUrl + "checkPemission", data, headers());
const storePresetVenue = (data) =>
  axios.post(baseUrl + "storeVenue", data, headers());
const storePresetVenueByMobile = (data, token) => {

    const headers = () => {
      return {
        headers: { Authorization: `${token}` },
      };
    };

    const params = {
      ...headers(),
    };
  
    return axios.post(baseUrl + "storeVenueT", data, params);
  }
const updatePresetVenue = (data) =>
  axios.put(baseUrl + "updateVenue", data, headers());
const updateUniform = (data) =>
  axios.post(baseUrl + "uniforms/update", data, headers());
const updateShoe = (data) =>
  axios.post(baseUrl + "shoes/update", data, headers());
const storeAnnouncement = (data) =>
  axios.post(baseUrl + "announcement/save", data, headers());
const updateAnnouncement = (data) =>
  axios.post(baseUrl + "announcement/update", data, headers());
const updateTabletsByArea = (data) =>
  axios.post(baseUrl + "tablets/update", data, headers());
const storeTabletAsset = (data) =>
  axios.post(baseUrl + "tablets/save", data, headers());
const storeTabletTransfer = (data) =>
  axios.post(baseUrl + "tablets/transfer", data, headers());
const cancelTabletTransfer = (data) =>
  axios.post(baseUrl + "tablets/cancel", data, headers());

const getTeams = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "teams/" + limit + "?page=" + page, params);
};

const getSurveys = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "surveys/" + limit + "?page=" + page, params);
};
const surveyReport = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "surveyReport", params);
};

const getUser = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "getUser/" + data, params);
};

const getUserDetail = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "getUserDetail/" + data, params);
};

const getUsers = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "users/" + limit + "?page=" + page, params);
};

const getBanks = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "banks", params);
};

const getBrands = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "brands", params);
};

const getRanges = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "ranges", params);
};

const getAreas = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "areas", params);
};

const getAreasByToken = (token) => {
  const headers = () => {
    return {
      headers: { Authorization: `${token}` },
    };
  };

  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "areas", params);
};

const getRegionsByToken = (token) => {
  const headers = () => {
    return {
      headers: { Authorization: `${token}` },
    };
  };

  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "regions", params);
};

const getVersionNumber = (data) => {
  const params = {
    ...headers(),
  };

  return axios.post(baseUrl + "getVersionNumber", data, params);
};

const getLocationCategories = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "locationCategories", params);
};

const getRegions = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "regions", params);
};

const getTeam = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "team/" + data, params);
};

const getProduct = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "product/" + data, params);
};

const getSurveyForm = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "surveyForm/" + data, params);
};

const getSurvey = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "survey/" + data, params);
};


const getTlWithTeam = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "tlWithTeam/" + data, params);
};

const usersWithTeam = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "usersWithTeam/" + data, params);
};

const getProjects = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "projects", params);
};

const getPrograms = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "programs/" + data, params);
};

const getProducts = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "products/" + limit + "?page=" + page, params);
};

const getBatProducts = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "productBatList", params);
};

const getPromotion = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "promotion/" + data, params);
};

const getPromotions = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "promotions/" + limit + "?page=" + page, params);
};

const getPositions = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "positions", params);
};

const getPresetVenues = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venues/" + limit + "?page=" + page, params);
};

const getPresetVenue = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "venue/" + data, params);
};

const getCheckInDetails = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "workProgress/" + limit + "?page=" + page, params);
};

const getSales = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "sales/" + limit + "?page=" + page, params);
};

const getSalesReport = (params) =>
  axios.get(`${baseUrl}sales/report`, {
    ...headers(),
    responseType: "blob",
    params,
  });

const getSurveysReport = (params) =>
axios.get(`${baseUrl}surveyExport`, {
  ...headers(),
  responseType: "blob",
  params,
});

const getSale = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "saleByTeam/" + limit + "?page=" + page, params);
};

const getSaleReport = (params) =>
  axios.get(`${baseUrl}saleByTeam/report`, {
    ...headers(),
    responseType: "blob",
    params,
  });

const getSaleRecordDetails = (type, date, userId, token) => {
  var thisUrl = baseUrl.substr(0, baseUrl.indexOf("/api/v1"));

  return axios.get(
    `${thisUrl}/app/api/report/${type}?date=${date}&userId=${userId}&token=${token}`
  );
};

const teamLeaderLiveGPSs = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "teamLeaderLiveGPSs/" + limit + "?page=" + page,
    params
  );
};

const getTeamLeaderLiveGPSsByArea = (area_id) =>
  axios.get(`${baseUrl}teamLeaderLiveGPSs/area/${area_id}`, { ...headers() });

const getTrialDetailByTeam = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "getTrialByTeam/" + limit + "?page=" + page,
    params
  );
};

const getCdcReport = (params) =>
  axios.get(`${baseUrl}cdc_report`, {
    ...headers(),
    responseType: "blob",
    params,
  });

const getCdc = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "getCdcTrials/" + limit + "?page=" + page, params);
};

const getCdcTrialReport = (params) =>
  axios.get(`${baseUrl}trial_report`, {
    ...headers(),
    responseType: "blob",
    params,
  });

const getCdcByTeam = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "getCdcByTeam/" + limit + "?page=" + page, params);
};

const getCdcByBa = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "getCdcByBa/" + limit + "?page=" + page, params);
};

const getCustomerDetail = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "getCustomerDetail", params);
};

const getUniforms = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "uniforms/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getShoes = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "shoes/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getAssetVariable = () => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "asset-transfer/getAssetVariable", params);
};

const getOtps = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "otp/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getAnnouncements = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "announcement/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getAnnouncement = (data) => {
  const params = {
    ...headers(),
  };

  return axios.get(baseUrl + "announcement/" + data, params);
};

const getTablets = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "tablets/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getTabletsByArea = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "tablets/inventory?page=" + page + "&limit=" + limit,
    params
  );
};

const getTabletsByTransfer = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "tablets/transfer?page=" + page + "&limit=" + limit,
    params
  );
};

const getTabletsByReceive = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "tablets/receive?page=" + page + "&limit=" + limit,
    params
  );
};

const getTabletsToTransferByArea = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "tablets/toTransferByArea", params);
};

const getOtpByWeek = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "otp/byWeek", params);
};

const getOtpByGraph = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "otp/byGraph", params);
};

const getOtpByChart = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "otp/byChart", params);
};

const getGraphDateDropdown = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "otp/getGraphDateDropdown", params);
};

const getTabletSummary = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "tablets/summary", params);
};

const getVenueAnalysisDetails = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "venue-analysis/all?page=" + page + "&limit=" + limit,
    params
  );
};

const getVenueAnalysisSob = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/getSob", params);
};

const getVenueAnalysisCategories = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/category/all", params);
};

const getVenueAnalysisCheckInByWeek = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/getCheckInByWeek", params);
};

const getVenueAnalysisChart = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/getChart", params);
};

const getCdcVenueTopTrial = (params) =>
  axios.get(`${baseUrl}venue-analysis/getCdcVenueTopTrial`, {
    ...headers(),
    params,
  });

const getSellableRange = () =>
  axios.get(`${baseUrl}dashboard/range`, {
    ...headers(),
  });

const getSalesVenueByRangeCategory = (params) =>
  axios.get(baseUrl + "venue-analysis/getSalesVenueByRangeCategory", {
    ...headers(),
    params,
  });

const exportOtp = (data) => {
  const params = {
    params: data,
    responseType: "blob",
    ...headers(),
  };

  return axios.get(baseUrl + "otp/export", params);
};

const getUsersPayroll = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "usersPayroll/" + limit + "?page=" + page, params);
};

const getUsersAttendance = (data, page, limit) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(
    baseUrl + "usersAttendance/" + limit + "?page=" + page,
    params
  );
};

const exportTablet = (data) => {
  const params = {
    params: data,
    responseType: "blob",
    ...headers(),
  };

  return axios.get(baseUrl + "tablets/export", params);
};

const exportInventoryTablet = (data) => {
  const params = {
    params: data,
    responseType: "blob",
    ...headers(),
  };

  return axios.get(baseUrl + "tablets/exportInventory", params);
};

const getVenuesMap = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/getVenuesMap", params);
};

const getVenueMapById = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "venue-analysis/getVenueMapById", params);
};

const getDashboardProduct = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/product", params);
};

const getProductSummary = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/product", params);
};

const getUserSummary = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/user", params);
};

const getUserSummaryNewUser = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/user/weekly", params);
};

const getUserSummaryActiveUser = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/user/weekly", params);
};

const getUserSummaryActiveTeam = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/user/weekly", params);
};

const getPresetVenueSummary = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/venue", params);
};

const getPresetVenueByType = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/venue/weekly", params);
};

const getCdcSummary = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/cdc", params);
};

const getCdcSummaryByCategoryType = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/cdc/category", params);
};

const getAttendanceSummary = (params) =>
  axios.get(`${baseUrl}dashboard/attendance`, {
    ...headers(),
    params,
  });

const getAttendanceMonthlyActiveUserByArea = (params) =>
  axios.get(`${baseUrl}dashboard/attendance/user_area`, {
    ...headers(),
    params,
  });

const getAttendanceMonthlyActiveTeam = (params) =>
  axios.get(`${baseUrl}dashboard/attendance/team`, {
    ...headers(),
    params,
  });

const getTeamArrivalAndDepartureSummary = (params) =>
  axios.get(`${baseUrl}dashboard/teamArrival`, {
    ...headers(),
    params,
  });

const getTeamArrivalAndDepartureByCategorySummary = (params) =>
  axios.get(`${baseUrl}dashboard/teamArrival/category`, {
    ...headers(),
    params,
  });

const getTrialSummary = (params) =>
  axios.get(`${baseUrl}dashboard/trial`, {
    ...headers(),
    params,
  });

const getTrialSummaryByCategory = (params) =>
  axios.get(`${baseUrl}dashboard/trial/category`, {
    ...headers(),
    params,
  });

const getDashboardDate = (params) =>
  axios.get(`${baseUrl}dashboard/date`, {
    ...headers(),
    params,
  });

const getSalesSummaryByType = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/sales", params);
};

const getSalesSummaryByCategory = (data) => {
  const params = {
    params: data,
    ...headers(),
  };

  return axios.get(baseUrl + "dashboard/sales/category", params);
};

export {
  headers,
  login,
  routeDetails,
  routeDetailsGPS,
  getUsers,
  getUser,
  getUserDetail,
  updateUser,
  storeUser,
  getTeams,
  getTeam,
  updateTeam,
  storeTeam,
  storeProduct,
  getSurvey,
  surveyReport,
  getSurveyForm,
  getSurveys,
  storeSurvey,
  updateSurvey,
  storeSurveyAnswer,
  getBanks,
  getBrands,
  getRanges,
  getAreas,
  getAreasByToken,
  getRegionsByToken,
  getRegions,
  getTlWithTeam,
  usersWithTeam,
  getProjects,
  getProducts,
  getProduct,
  getPromotions,
  updateProduct,
  checkPermission,
  getPositions,
  getPresetVenue,
  getPresetVenues,
  getCheckInDetails,
  getPrograms,
  getLocationCategories,
  storePresetVenue,
  teamLeaderLiveGPSs,
  getTeamLeaderLiveGPSsByArea,
  getTrialDetailByTeam,
  getCdcTrialReport,
  getCdc,
  getCdcReport,
  getCdcByTeam,
  getCdcByBa,
  getCustomerDetail,
  getUniforms,
  updateUniform,
  getShoes,
  updateShoe,
  getAssetVariable,
  getOtps,
  storeAnnouncement,
  getAnnouncements,
  getAnnouncement,
  updateAnnouncement,
  getTablets,
  getTabletsByArea,
  updateTabletsByArea,
  getTabletsByTransfer,
  getTabletsByReceive,
  storeTabletAsset,
  getTabletsToTransferByArea,
  storeTabletTransfer,
  cancelTabletTransfer,
  getOtpByWeek,
  getOtpByGraph,
  getOtpByChart,
  getGraphDateDropdown,
  getTabletSummary,
  getVenueAnalysisDetails,
  getVenueAnalysisSob,
  getVenueAnalysisCategories,
  getVenueAnalysisCheckInByWeek,
  getVenueAnalysisChart,
  getCdcVenueTopTrial,
  getSellableRange,
  getSalesVenueByRangeCategory,
  exportOtp,
  exportTablet,
  exportInventoryTablet,
  getUsersPayroll,
  getUsersAttendance,
  getSales,
  getSalesReport,
  getSurveysReport,
  getSale,
  getSaleReport,
  getSaleRecordDetails,
  getVenuesMap,
  getVenueMapById,
  getDashboardProduct,
  getProductSummary,
  getUserSummary,
  getUserSummaryNewUser,
  getUserSummaryActiveUser,
  getUserSummaryActiveTeam,
  getAttendanceSummary,
  getAttendanceMonthlyActiveUserByArea,
  getAttendanceMonthlyActiveTeam,
  getTeamArrivalAndDepartureSummary,
  getTeamArrivalAndDepartureByCategorySummary,
  getTrialSummary,
  getTrialSummaryByCategory,
  getDashboardDate,
  getPresetVenueSummary,
  getPresetVenueByType,
  getCdcSummary,
  getCdcSummaryByCategoryType,
  getSalesSummaryByType,
  getSalesSummaryByCategory,
  updatePresetVenue,
  getBatProducts,
  storePromotion,
  getPromotion,
  updatePromotion,
  storePresetVenueByMobile,
  getVersionNumber,
};
